import React, { FunctionComponent } from 'react';
import styles from './ProfileMenu.module.scss';
import { _t } from 'app/utils/i18n';
import { UserImg, DownArrowIcon } from 'app/assets/images/icons';
import { makeStyles } from '@material-ui/core/styles';

import {
  getFromLocalStorage,
  constants,
  setInLocalStorage,
} from '../../utils/localStorage';

import {
  Box,
  Menu,
  MenuItem,
  Divider,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { path } from 'app/utils/path';
import { logout } from 'auth/Requests';

import {
  ProfileIconDd,
  SettingsIconDd,
  LanguageIconDd,
  LogoutIconDd,
} from 'app/assets/images/icons';
import { useMutation } from 'react-query';
import { useAuth } from 'app/context/auth';
import { useModal } from 'app/context/Modal';

const useStyles = makeStyles((theme) => ({
  paper: {
    border: '1px solid var(--borderColor)',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    padding: '10px 0',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    top: '45px !important',
    width: '178px',
  },
}));

const ProfileMenu: FunctionComponent = () => {
  const classes = useStyles();
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { show, hide } = useModal();

  const open = Boolean(anchorEl);

  const handleLogOut = () => {
    show({
      message: _t('basic:logoutmessage'),
      onOk: () => {
        logoutMutation.mutate();

        hide();
      },
    });
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const currentLanguage = getFromLocalStorage(constants.language);
  const darkMode = getFromLocalStorage(constants.darkMode);

  const setLang = (lng: string) => {
    setInLocalStorage(constants.language, lng);
    window.location.reload();
  };

  const logoutMutation = useMutation(logout, {
    onSuccess: () => {
      localStorage.clear();
      sessionStorage.clear();
      setInLocalStorage(constants.language, currentLanguage);
      setInLocalStorage(constants.darkMode, darkMode);
      setTimeout(() => {
        // replace(path.auth.SIGN_IN);
        window.location.reload();
      }, 0);
    },
  });
  return (
    <div className={styles.ProfileMenu}>
      <Box
        style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}
        onClick={handleClick}
        data-testid="profile_menu_container"
      >
        <Tooltip title={`${_t('basic:Account_settings')}`}>
          <IconButton size="small" style={{ marginLeft: 2 }}>
            {user?.image_url ? (
              <div data-testid="userImgContainer" className={styles.userImg}>
                <img alt="user" src={user?.image_url} />
              </div>
            ) : (
              <UserImg data-testid="defaultUserImg" />
            )}
            <p className={styles.name}>{user?.name}</p>
            <div className={`${styles.arrow} ${open ? styles.open : ''}`}>
              <DownArrowIcon />
            </div>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          className: `${classes.paper} menuArrow`,
          elevation: 0,
          style: {
            overflow: 'visible',
            marginTop: 1.5,
            top: '35px',
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        data-testid="profile_menu"
      >
        <MenuItem data-testid="profileButton">
          <Link to={`${path.users.USER_PROFILE_URI}`}>
            <ProfileIconDd />
            {_t('basic:profile')}
          </Link>
        </MenuItem>
        <MenuItem data-testid="editProfileButton">
          <Link to={`${path.users.EDIT_PROFILE}`}>
            <SettingsIconDd />
            {_t('basic:edit_profile')}
          </Link>
        </MenuItem>
        <MenuItem>
          {currentLanguage == 'en' ? (
            <p
              className="logout"
              style={{ color: 'var(--mainColor)' }}
              onClick={() => setLang('ar')}
              data-testid="changeLangToArabic"
            >
              <LanguageIconDd />
              {_t('basic:ar')}
            </p>
          ) : (
            <p
              className="logout"
              style={{ color: 'var(--mainColor)' }}
              onClick={() => setLang('en')}
              data-testid="changeLangToEnglish"
            >
              <LanguageIconDd />
              {_t('basic:en')}
            </p>
          )}
        </MenuItem>
        <Divider />
        <MenuItem>
          <p
            className="logout"
            style={{ color: 'var(--mainColor)' }}
            onClick={handleLogOut}
            data-testid="logOutButton"
          >
            <LogoutIconDd />
            {_t('basic:logout')}
          </p>
        </MenuItem>
      </Menu>
    </div>
  );
};
export default ProfileMenu;
